import type { Benefit, FooterColumn } from "../types/marketplace";

interface FooterProps {
  benefits: Benefit[];
  columns: FooterColumn[];
}

function Footer({ benefits, columns }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-benefits">
        {benefits.map((benefit) => (
          <div key={benefit.title}>
            <span>{benefit.icon}</span>
            <strong>{benefit.title}</strong>
            <small>{benefit.description}</small>
          </div>
        ))}
      </div>

      <div className="container footer-links">
        {columns.map((column) => (
          <div key={column.title}>
            <h4>{column.title}</h4>
            {column.links.map((link) => (
              <a href="#ayuda" key={link}>
                {link}
              </a>
            ))}
          </div>
        ))}
      </div>

      <div className="container footer-bottom">
        <strong>
          <span>M</span> Mika Market
        </strong>
        <p>{currentYear} Mika Market. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;
